import { useQuery } from "@tanstack/react-query";

import type { PaymentSource } from "features/payment-methods/types";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get } from "common/helpers/HTTP";

async function getPaymentSourcesRequest(workspaceId?: string) {
  return (
    await get(
      workspaceId
        ? `workspaces/${workspaceId}/payment-sources`
        : "billing/payment-sources",
    )
  ).payment_sources;
}

export default function usePaymentSources() {
  const { id: workspaceId, role } = useSelectedWorkspaceContext();

  const { data: paymentSources, isLoading: isLoadingPaymentSources } = useQuery<
    PaymentSource[]
  >({
    queryKey: CUSTOMER_QUERY_KEYS.paymentSourceKeys.list(),
    queryFn: () =>
      getPaymentSourcesRequest(role === "owner" ? undefined : workspaceId),
  });

  return {
    paymentSources,
    isLoadingPaymentSources,
  };
}
